import Cookies from 'js-cookie'

/**
 *判断浏览器是否为微信
 */
export function isWxBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
}

/**
 * 微信登陆后插入微信登录信息
 */
export function setWxLoginInfo(unionId) {
    Cookies.set('wxLoginInfo', unionId)
}

/**
 * 获取微信登录信息
 */
export function getWxLoginInfo() {
    return Cookies.get('wxLoginInfo');
}

/**
 * 对url进行urlEncode操作
 * @param str
 * @returns {*}
 */
export function urlEncode(str) {
    str = (str + '').toString();
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

/**
 *获取登录状态
*/
export function isLogin() {
    let type = Cookies.get('type') || '0'
    if (type === '0') {
        return Cookies.get('session') != null
    }else{
        return Cookies.get('session1') != null
    }
}

/**
 *设置登录状态
 */
export function setLoginState(session) {
    let type = Cookies.get('type') || '0'
    if (type === '0') {
        Cookies.set('session', session, {expires: 1 / 24 * session.expireTime})//以小时为单位 * N小时
    }else{
        Cookies.set('session1', session, {expires: 1 / 24 * session.expireTime})//以小时为单位 * N小时
    }
}

/**
 * map key排序
 * @Author cpgu 2022/11/27
 */
export function sortMap(map, isKeyUpSort){
    let keys = new Array()
    for (let key of map.keys()) {
        keys.push(key)
    }

    if (isKeyUpSort) {
        keys.sort(function(key1, key2) {
            return key1 - key2
        })
    } else {
        keys.sort(function(key1, key2) {
            return key2 - key1
        })
    }

    let newMap = new Map()
    keys.forEach(key => {
        newMap.set(key, map.get(key))
    })

    return newMap
}
